import { useEffect, useState } from "react";
import { MdEdit, MdVisibility } from "react-icons/md";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router";
import Select from "react-select";
import Loader from "../../../Components/Loader";
import CheckAccess from "../../../Function/CheckAccess";
import pickupTrackingService from "../../../Services/pickupTrackingService";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

let currentPage1 = 1;

const ProviderOption = [
  { value: "ALL", label: "All" },
  { value: "BOOKING_CONFIRMED", label: "Pick Up in progress" },
  { value: "SHIPMENT_AT_WAREHOUSE", label: "Export formalities in progress" },
  { value: "DEPARTED", label: "In transit" },
  { value: "ARRIVED", label: "Import formalities in progress" },
  { value: "DELIVERED", label: "Delivered" },
];

export const PickupTrackingList = () => {
  const history = useHistory();
  const [dataList, setDataList] = useState([]);
  const [serviceProvider, setServiceProvider] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [loader, setLoader] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);

  let user_type = localStorage.getItem("user_type");

  const getData = () => {
    let Filter = {
      page: currentPage,
      limit: pagination.limit,
    };

    if (serviceProvider && serviceProvider.value !== 'ALL') {
      Filter.search1 = serviceProvider.value;
    }
    if (searchText) {
      Filter.search = searchText;
    }

    setLoader(true);
    pickupTrackingService.getPickupTrackingList(Filter).then((result) => {
      if (result.status === true) {
        setDataList(result.data);
        setPagination({ ...pagination, ...result.pagination });
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    getData();
  }, [serviceProvider, searchText, currentPage]);

  const searchTracking = (text) => {
    setSearchText(text);
    setCurrentPage(1);
  };

  const convertToDate = (data) => {
    return new Date(data).toLocaleDateString();
  };

  const getTrackingDate = (data) => {
    let val = data?.job_status_values.map((item1) => {
      if (item1.job_status === data.job_status) {
        return convertToDate(item1.tracking_date);
      }
      return null;
    });
    return val;
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1;
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const appendHandler = (event, key) => {
    event.target.closest("tr").classList.toggle("showTr");
    let arry = [...dataList];
    dataList.map((val, ind) => {
      if (key === ind) {
        val.show = Boolean(!val.show);
      }
    });
    setDataList(arry);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-sm-3">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onKeyUp={(e) => searchTracking(e.target.value)}
                />
              </div>
              <div className="col-sm-3">
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  onChange={(e) => {
                    setServiceProvider(e);
                    setCurrentPage(1);
                  }}
                  placeholder="Shipment Status"
                  options={ProviderOption}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Job No.</th>
                    <th>Customer Name</th>
                    <th>Shipment Status</th>
                    <th>Seller Order Id</th>
                    <th>Tracking Id</th>
                    <th>Status Date</th>
                    <th>Expected Delivery Date</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {dataList &&
                    dataList.map((item, key) => {
                      let firstRow = item?.main;
                      return (
                        <>
                          <tr className="parentTr">
                            <td>
                              {
                                item.jobs.length > 1 ?
                                  <button
                                    className="btn btn-primary p-1 px-2"
                                    type="button"
                                    onClick={(event) => appendHandler(event, key)}
                                  >
                                    {item.show === false ? (
                                      <FaAngleUp />
                                    ) : (
                                      <FaAngleDown />
                                    )}{" "}
                                    {item.jobs.length}
                                  </button>
                                  :
                                  <button
                                    className="btn btn-primary p-1 px-2"
                                    type="button"

                                  >
                                    {1}
                                  </button>
                              }
                            </td>
                            <td>{firstRow?.job_token}</td>
                            <td>{firstRow?.user_full_name}</td>
                            <td>{firstRow?.job_status}</td>
                            <td>{firstRow?.seller_order_id}</td>
                            <td>{firstRow?.tracking_id}</td>
                            <td>
                              {(firstRow?.job_status_values && getTrackingDate(firstRow)) || "-"}
                            </td>
                            <td>
                              {firstRow?.expacted_date
                                ? convertToDate(firstRow.expacted_date)
                                : ""}
                            </td>
                            <td>
                              {(CheckAccess(45, "edit") || user_type === "SUPERADMIN") && (
                                <MdEdit
                                  className="pointer"
                                  onClick={() =>
                                    history.push(
                                      `edit-pickup-tracking?id=${firstRow?.pickup_id}`
                                    )
                                  }
                                  color="#0323fe"
                                  size="25px"
                                />
                              )}
                              <MdVisibility
                                className="pointer"
                                onClick={() =>
                                  history.push(
                                    `pickup-tracking-details?id=${firstRow?.pickup_id}`
                                  )
                                }
                                color="#0323fe"
                                size="25px"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td colSpan="13">
                              <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th rowSpan="2">#</th>
                                    <th>Job No.</th>
                                    <th>Customer Name</th>
                                    <th>Shipment Status</th>
                                    <th>Seller Order Id</th>
                                    <th>Tracking Id</th>
                                    <th>Status Date</th>
                                    <th>Expected Delivery Date</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.jobs.map((val, ind) => {
                                    return (
                                      <tr>
                                        <td>{ind + 1}</td>
                                        <td>{val?.job_token}</td>
                                        <td>{val?.user_full_name}</td>
                                        <td>{val?.job_status}</td>
                                        <td>{val?.seller_order_id}</td>
                                        <td>{val?.tracking_id}</td>
                                        <td>
                                          {(val?.job_status_values && getTrackingDate(val)) || "-"}
                                        </td>
                                        <td>
                                          {val?.expacted_date
                                            ? convertToDate(val.expacted_date)
                                            : ""}
                                        </td>
                                        <td>
                                          {(CheckAccess(45, "edit") || user_type === "SUPERADMIN") && (
                                            <MdEdit
                                              className="pointer"
                                              onClick={() =>
                                                history.push(
                                                  `edit-pickup-tracking?id=${val.pickup_id}`
                                                )
                                              }
                                              color="#0323fe"
                                              size="25px"
                                            />
                                          )}
                                          <MdVisibility
                                            className="pointer"
                                            onClick={() =>
                                              history.push(
                                                `pickup-tracking-details?id=${val.pickup_id}`
                                              )
                                            }
                                            color="#0323fe"
                                            size="25px"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </td>
                          </tr>

                        </>
                      );
                    })}
                </tbody>
              </table>
              {dataList && dataList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {dataList &&
                dataList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
              <Loader isShow={loader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
